import { defaultShouldDehydrateQuery } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import {
  ENUMERATIONS_CACHE_VERSION,
  ENUMERATIONS_GC_TIME,
  ENUMERATIONS_QUERY_KEYS,
  ENUMERATIONS_RETRY_COUNT,
  ENUMERATIONS_STALE_TIME,
  isEnumerationsQuery,
} from "../../common/api/queries";
import { queryClient } from "../../common/api/queryClient";
import { queryPersister } from "../store/queryPersister";

type Props = {
  children: React.ReactNode;
};

// Prefix match, so the enumerations and the permission definitions get these. One retry caps a dead backend at two requests.
queryClient.setQueryDefaults(ENUMERATIONS_QUERY_KEYS.enumerations(), {
  staleTime: ENUMERATIONS_STALE_TIME,
  gcTime: ENUMERATIONS_GC_TIME,
  retry: ENUMERATIONS_RETRY_COUNT,
});

export const ReactQueryProvider = ({ children }: Props) => {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: queryPersister,
        maxAge: ENUMERATIONS_GC_TIME,
        buster: ENUMERATIONS_CACHE_VERSION,
        // Only successful enumerations survive a reload - persisting the rest would just bloat IndexedDB.
        dehydrateOptions: {
          shouldDehydrateQuery: (query) => defaultShouldDehydrateQuery(query) && isEnumerationsQuery(query.queryKey),
        },
      }}
    >
      {children}
      <ReactQueryDevtools initialIsOpen={false} />
    </PersistQueryClientProvider>
  );
};
